<template>
    <div class="attribute-data-box" itemscope itemtype ="https://schema.org/Vehicle">
        <div class="row">
            <data-entry-column :title="$t('pds.vehicle.condition.label')" :value="isNew" :is-loading="isLoading"></data-entry-column>
            <data-entry-column :title="$t('pds.power.title')" :value="getPower" :is-loading="isLoading" itemprop="vehicleEngine"></data-entry-column>
            <data-entry-column :title="$t('pds.doors.title')" :value="getDoors" :is-loading="isLoading" v-if="showDoors" itemprop="numberOfDoors"></data-entry-column>
            <data-entry-column :title="$t('pds.seats.title')" :value="getSeats" :is-loading="isLoading" itemprop="VehicleSeatingCapacity"></data-entry-column>
            <data-entry-column :title="$t('pds.seat_height.title')" :value="getSeatHeight" :is-loading="isLoading" v-if="showSeatHeight"></data-entry-column>
            <data-entry-column :title="$t('pds.fuel.title')" :value="getFuel" :is-loading="isLoading" itemprop="fuelType"></data-entry-column>
            <data-entry-column :title="$t('pds.category.title')" :value="getCategory" :is-loading="isLoading" itemprop="bodyType"></data-entry-column>
            <data-entry-column :title="$t('pds.first_registration.title')" :value="getFirstRegistration" :is-loading="isLoading" itemprop="dateVehicleFirstRegistered"></data-entry-column>
            <data-entry-column :title="$t('pds.mileage.title')" :value="getCurrentMiles" :is-loading="isLoading"></data-entry-column>
            <data-entry-column :title="$t('pds.gearshift.title')" :value="getGearshift" :is-loading="isLoading" itemprop="vehicleTransmission"></data-entry-column>
            <data-entry-column :title="$t('pds.colour.title')" :value="getColor" :is-loading="isLoading"></data-entry-column>
            <data-entry-column v-if="entry" :title="$t('pds.listing_price.title')" :value="getFormatetPrice" :is-loading="isLoading"></data-entry-column>
        </div>
    </div>
</template>

<script>
import DataEntryColumn from "../atoms/DataEntryColumn.vue";

export default {
    name: 'VehicleData',
    components: {
        DataEntryColumn,
    },
    props: {
        entry: null,
        isLoading: true
    },
    computed: {
        isNew(){
            return this.entry ? this.$t('pds.vehicle.condition.'+this.entry.vehicle_condition) : ''
        },
        getSeats(){
            return this.entry ? this.entry.seats : ''
        },
        getDoors(){
            return this.entry ? this.entry.doors : ''
        },
        getPower(){
            return this.entry ? `${ this.entry.power.hp } ${this.$root.whitelabel.getPowerUnit()} (${ this.entry.power.kw } ${this.$t('cat.product_tile.electric.unit')})` : ''
        },
        getFuel(){
            if(this.entry) {
                const { slug } = this.entry.fuel
                return this.entry ? this.$t(`general.fuel.${slug}`) : ''
            }

            return ''
        },
        getCategory(){
            if(this.entry) {
                const { slug } = this.entry.category
                return this.entry ? this.$t(`general.vehicleCategory.${slug}`) : ''
            }
            return ''
        },
        getFirstRegistration(){
            return this.entry && this.entry.first_registration ? new Date(this.entry.first_registration).getFullYear() : this.$t('pds.firstRegistration.notAvailable')
        },
        getCurrentMiles(){
            if(this.entry){
                const number = this.entry.current_miles.replace(' Km','')
                return `${this.$n(parseInt(number), 'number')} ${this.$root.whitelabel.getMileageUnit()}`
            }
            return ''
        },
        getGearshift(){
            if(this.entry) {
                const {slug} = this.entry.gearshift
                return this.entry ? this.$t(`general.gearshift.${slug}`) : ''
            }
            return ''
        },
        getColor(){
            return this.entry ? this.entry.exterior_color : ''
        },
        showDoors(){
            return this.entry.category.parent_type != 'Motorbike'
        },
        getSeatHeight(){
            return this.entry ? this.entry.seat_height : ''
        },
        showSeatHeight(){
            return this.entry.category.parent_type == 'Motorbike'
        },
        getFormatetPrice() {
            if(this.entry && this.entry.listing_price){
                return this.$root.whitelabel.getFormatetPrice(this.entry.listing_price)
            }
        }
    }
}
</script>
